<div class="grid grid-rows-3 xl:grid-rows-2 grid-flow-col my-5 w-full">
    <div *ngFor="let filter of filters"
        class="flex sm:flex-row flex-col items-start justify-start  my-1 font-normal sm:items-center ">
        <div class="w-[200px] ">
            {{ getFilterLabel(filter) }}
        </div>

        <div
            class="flex flex-row justify-start items-center  py-2 overflow-auto">
            <div *ngFor="let option of filter.options">
                <button
                    class="min-w-[110px] py-1 text-base font-normal rounded-full  mx-2"
                    [ngClass]="buttonSelect.get(filter.filterBy) === optionValue(option) ? 'theme-background text-color-blue-dark ' : 'theme-color '"
                    (click)="activateButton(filter.filterBy, optionValue(option))"
                    mat-raised-button>
                    <div class="flex flex-row "
                        [ngClass]="buttonSelect.get(filter.filterBy) === optionValue(option) ? 'justify-between items-center' : 'justify-center'">
                        <div>

                            {{((optionLabel(option) | translate) | async)}}
                        </div>
                        <mat-icon class="material-icons"
                            [ngClass]="buttonSelect.get(filter.filterBy) === optionValue(option) ? '' : 'hidden-icon' ">
                            cancel
                        </mat-icon>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>